(() => {
  const threshold = 9350;
  const shopAll = '/collections/shop-all';
  const newIn = '/collections/new-in';
  let timer;
  let refreshing = false;
  let allThreePatchStarted = false;

  const money = (cents) => new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: cents % 100 ? 2 : 0,
  }).format(cents / 100);

  function emptyState(container, drawer = false) {
    if (!container || container.dataset.tscEmptyEnhanced) return;

    const heading = container.querySelector('.cart__empty-text, h1, h2');
    if (heading && heading.textContent.trim() !== 'Your cart is ready when you are.') {
      heading.textContent = 'Your cart is ready when you are.';
    }

    if (!container.querySelector('.tsc-empty-copy')) {
      const copy = document.createElement('p');
      copy.className = 'tsc-empty-copy';
      copy.textContent = 'Start with one versatile piece, then build from there.';
      heading ? heading.after(copy) : container.prepend(copy);
    }

    if (!container.querySelector('.tsc-empty-actions')) {
      const actions = document.createElement('div');
      actions.className = 'tsc-empty-actions';
      actions.innerHTML = `
        <a class="button" href="${shopAll}">Shop All</a>
        <a class="button button--secondary" href="${newIn}">Explore New In</a>
      `;
      const oldButton = container.querySelector('a.button');
      oldButton ? oldButton.replaceWith(actions) : container.append(actions);
    }

    container.querySelectorAll(
      '.cart-drawer__collection, .cart__login-title, .cart__login-paragraph'
    ).forEach((element) => { element.style.display = 'none'; });

    if (drawer) container.closest('.cart-drawer__warnings')?.classList.add('tsc-cart-empty-ready');
    container.dataset.tscEmptyEnhanced = 'true';
  }

  function enhanceEmptyStates() {
    emptyState(document.querySelector('#CartDrawer .cart-drawer__empty-content'), true);
    emptyState(document.querySelector('cart-items .cart__warnings'));

    document.querySelectorAll('a[href*="javascript:history.back"]').forEach((link) => {
      if (link.getAttribute('href') !== shopAll) link.href = shopAll;
      if (link.textContent.trim() !== 'Shop All') link.textContent = 'Shop All';
    });
  }

  function headings() {
    const drawer = document.querySelector('#CartDrawer .drawer__heading');
    const page = document.querySelector('cart-items .title--primary');
    if (drawer && drawer.textContent.trim() !== 'Your Cart') drawer.textContent = 'Your Cart';
    if (page && page.textContent.trim() !== 'Your Cart') page.textContent = 'Your Cart';
  }

  function viewCart(target) {
    if (!target || target.querySelector('[data-tsc-view-cart]')) return;
    const link = document.createElement('a');
    link.href = window.routes?.cart_url || '/cart';
    link.className = 'tsc-cart-view-link';
    link.dataset.tscViewCart = '';
    link.textContent = 'View Cart';
    (target.querySelector('.cart__ctas') || target).after(link);
  }

  function shippingState(cart) {
    if (cart.currency !== 'USD') {
      return {
        signature: `${cart.currency}:${cart.item_count}`,
        label: '<strong>Free U.S. shipping</strong><span>On qualifying orders</span>',
        progress: 0,
      };
    }

    const hasLookBundle =
      Array.isArray(cart.items) &&
      cart.items.some((item) => Number(item.product_id) === 9195261624494) &&
      cart.items.some((item) => Number(item.variant_id) === 48910787051694);

    if (hasLookBundle) {
      return {
        signature: `USD:look:${cart.total_price}:${cart.item_count}`,
        label: '<strong>Free U.S. shipping unlocked</strong><span>Complete the Look offer</span>',
        progress: 100,
      };
    }

    const hasEarringsBundle =
      Array.isArray(cart.items) &&
      cart.items.some((item) => Number(item.product_id) === 9195261624494) &&
      cart.items.some((item) => Number(item.variant_id) === 48915080183982);

    if (hasEarringsBundle) {
      return {
        signature: `USD:earrings:${cart.total_price}:${cart.item_count}`,
        label: '<strong>Free U.S. shipping unlocked</strong><span>Dress + earrings offer</span>',
        progress: 100,
      };
    }

    const remaining = Math.max(threshold - cart.total_price, 0);
    return {
      signature: `USD:${cart.total_price}:${cart.item_count}`,
      label: remaining
        ? `<strong>${money(remaining)} away</strong><span>from free U.S. shipping</span>`
        : '<strong>Free U.S. shipping unlocked</strong><span>Threshold reached</span>',
      progress: Math.min(Math.round((cart.total_price / threshold) * 100), 100),
    };
  }

  function progress(target, cart) {
    if (!target || !cart.item_count) return;
    const state = shippingState(cart);
    let block = target.querySelector(':scope > [data-tsc-shipping-progress]');

    if (!block) {
      block = document.createElement('div');
      block.className = 'tsc-cart-progress';
      block.dataset.tscShippingProgress = '';
      block.innerHTML = `
        <div class="tsc-cart-progress__label"></div>
        <div class="tsc-cart-progress__track" aria-hidden="true">
          <div class="tsc-cart-progress__bar"></div>
        </div>
      `;
      target.prepend(block);
    }

    if (block.dataset.signature !== state.signature) {
      block.dataset.signature = state.signature;
      block.querySelector('.tsc-cart-progress__label').innerHTML = state.label;
      block.style.setProperty('--tsc-cart-progress', `${state.progress}%`);
    }
  }

  function assurance(target) {
    if (!target || target.querySelector(':scope > [data-tsc-cart-assurance]')) return;
    const element = document.createElement('div');
    element.className = 'tsc-cart-assurance';
    element.dataset.tscCartAssurance = '';
    element.innerHTML = '<span>Tracked delivery</span><span>Secure checkout</span>';
    target.append(element);
  }

  async function refresh() {
    if (refreshing) return;
    refreshing = true;

    try {
      headings();
      enhanceEmptyStates();

      const response = await fetch(`${window.routes?.cart_url || '/cart'}.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) return;
      const cart = await response.json();
      const drawerFooter = document.querySelector('#CartDrawer .drawer__footer');
      const cartBlocks = document.querySelector('#main-cart-footer .cart__blocks');

      progress(drawerFooter, cart);
      progress(cartBlocks, cart);

      if (cart.item_count) {
        assurance(drawerFooter);
        assurance(cartBlocks);
        viewCart(drawerFooter);
      }
    } catch (error) {
      console.debug('Cart enhancement unavailable', error);
    } finally {
      refreshing = false;
    }
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(refresh, 180);
  }

  function isOwnEnhancementNode(node) {
    const element = node?.nodeType === Node.ELEMENT_NODE ? node : node?.parentElement;
    return Boolean(element?.closest?.(
      '[data-tsc-shipping-progress], [data-tsc-cart-assurance], [data-tsc-view-cart], .tsc-empty-copy, .tsc-empty-actions'
    ));
  }

  function observe(target) {
    if (!target || target.dataset.tscCartObserved) return;
    target.dataset.tscCartObserved = 'true';
    new MutationObserver((mutations) => {
      const hasExternalChange = mutations.some((mutation) => {
        if (!isOwnEnhancementNode(mutation.target)) return true;
        return Array.from(mutation.addedNodes || []).some((node) => !isOwnEnhancementNode(node)) ||
          Array.from(mutation.removedNodes || []).some((node) => !isOwnEnhancementNode(node));
      });
      if (hasExternalChange) schedule();
    }).observe(target, {
      childList: true,
      subtree: true,
    });
  }

  function getVariantSize(offer, variant) {
    const sizeIndex = Number(offer.dataset.sizeIndex || 1);
    return String(variant?.options?.[sizeIndex] || '');
  }

  function findAllThreeVariant(offer, color, size) {
    const colorIndex = Number(offer.dataset.colorIndex || 0);
    const sizeIndex = Number(offer.dataset.sizeIndex || 1);
    return offer.variants.find((variant) =>
      variant.available &&
      String(variant.options?.[colorIndex] || '').trim().toLowerCase() === color &&
      String(variant.options?.[sizeIndex] || '') === String(size)
    );
  }

  function buildSizeOptions(offer, color, selectedSize) {
    const colorIndex = Number(offer.dataset.colorIndex || 0);
    const sizeIndex = Number(offer.dataset.sizeIndex || 1);
    const sizeOrder = [];

    offer.variants.forEach((variant) => {
      const variantColor = String(variant.options?.[colorIndex] || '').trim().toLowerCase();
      const size = String(variant.options?.[sizeIndex] || '');
      if (variantColor === color && size && !sizeOrder.includes(size)) sizeOrder.push(size);
    });

    return sizeOrder.map((size) => {
      const variant = findAllThreeVariant(offer, color, size);
      const selected = size === selectedSize ? ' selected' : '';
      const disabled = variant ? '' : ' disabled';
      return `<option value="${size.replace(/"/g, '&quot;')}"${selected}${disabled}>${size}</option>`;
    }).join('');
  }

  function ensureAllThreeSizePanel(offer) {
    const allThreeInput = offer?.querySelector('input[name^="PurchaseOption-"][value="all3"]');
    if (!allThreeInput) return null;

    const saving = allThreeInput.closest('.tsc-buy-two__choice')?.querySelector('.tsc-buy-two__saving');
    const savingText = 'Black + Cream + Brown · Choose each size · Free U.S. shipping';
    if (saving && saving.textContent.trim() !== savingText) saving.textContent = savingText;

    let panel = offer.querySelector('[data-all3-sizes]');
    const primary = offer.selectedPrimaryVariant;
    const primarySize = getVariantSize(offer, primary) || 'S';

    if (!panel) {
      panel = document.createElement('div');
      panel.className = 'tsc-buy-two__second tsc-buy-two__all3-sizes';
      panel.dataset.all3Sizes = '';
      panel.hidden = true;
      panel.innerHTML = `
        <div class="tsc-buy-two__second-heading">
          <div>
            <p class="tsc-buy-two__second-title">Choose each dress size</p>
            <p class="tsc-buy-two__second-note">One Black, one Cream and one Brown dress. Sizes can be different.</p>
          </div>
        </div>
        <div class="tsc-all3-size-row">
          <span class="tsc-buy-two__shawl-label">1 · Black</span>
          <strong data-all3-primary-size>${primarySize}</strong>
          <small>Uses the size selected above.</small>
        </div>
        <label class="tsc-buy-two__shawl-label" for="All3-Cream-${offer.dataset.productId || 'dress'}">2 · Cream size</label>
        <select id="All3-Cream-${offer.dataset.productId || 'dress'}" class="tsc-buy-two__shawl-select" data-all3-size="cream">
          ${buildSizeOptions(offer, 'cream', primarySize)}
        </select>
        <label class="tsc-buy-two__shawl-label" for="All3-Brown-${offer.dataset.productId || 'dress'}">3 · Brown size</label>
        <select id="All3-Brown-${offer.dataset.productId || 'dress'}" class="tsc-buy-two__shawl-select" data-all3-size="brown">
          ${buildSizeOptions(offer, 'brown', primarySize)}
        </select>
        <p class="tsc-buy-two__terms">Black uses the size selected above. Cream and Brown can be set independently. All 3 Colors remains $149 with free U.S. shipping.</p>
      `;

      const choices = offer.querySelector('.tsc-buy-two__choices');
      choices?.after(panel);

      panel.addEventListener('change', (event) => {
        const select = event.target.closest('[data-all3-size]');
        if (!select) return;
        select.dataset.tscUserSet = 'true';
      });
    }

    const primarySizeLabel = panel.querySelector('[data-all3-primary-size]');
    if (primarySizeLabel && primarySizeLabel.textContent !== primarySize) primarySizeLabel.textContent = primarySize;

    ['cream', 'brown'].forEach((color) => {
      const select = panel.querySelector(`[data-all3-size="${color}"]`);
      if (!select) return;
      const current = select.value;
      const desired = select.dataset.tscUserSet === 'true' && current ? current : primarySize;
      select.innerHTML = buildSizeOptions(offer, color, desired);
      if (select.value !== desired && findAllThreeVariant(offer, color, desired)) select.value = desired;
    });

    return panel;
  }

  function patchAllThreeSizes() {
    if (allThreePatchStarted) return;
    allThreePatchStarted = true;

    if (!window.customElements?.whenDefined) return;

    customElements.whenDefined('buy-two-offer').then(() => {
      const Offer = customElements.get('buy-two-offer');
      if (!Offer || Offer.prototype.__tscAllThreeSizesPatched) return;

      const originalUpdateState = Offer.prototype.updateState;
      if (typeof originalUpdateState !== 'function') return;

      Object.defineProperty(Offer.prototype, 'selectedAllThreeVariants', {
        configurable: true,
        get() {
          const primary = this.selectedPrimaryVariant;
          if (!primary) return [];

          const primarySize = getVariantSize(this, primary);
          const panel = ensureAllThreeSizePanel(this);
          const creamSize = panel?.querySelector('[data-all3-size="cream"]')?.value || primarySize;
          const brownSize = panel?.querySelector('[data-all3-size="brown"]')?.value || primarySize;

          const variants = [
            findAllThreeVariant(this, 'black', primarySize),
            findAllThreeVariant(this, 'cream', creamSize),
            findAllThreeVariant(this, 'brown', brownSize),
          ];

          return variants.every(Boolean) ? variants : [];
        },
      });

      Offer.prototype.updateState = function patchedUpdateState(...args) {
        const panel = ensureAllThreeSizePanel(this);
        const result = originalUpdateState.apply(this, args);
        if (panel) panel.hidden = this.mode !== 'all3';
        return result;
      };

      Offer.prototype.__tscAllThreeSizesPatched = true;

      document.querySelectorAll('buy-two-offer').forEach((offer) => {
        ensureAllThreeSizePanel(offer);
        offer.updateState?.();
      });

      document.addEventListener('change', (event) => {
        const info = event.target.closest?.('.product__info-container');
        if (!info) return;
        window.setTimeout(() => {
          info.querySelectorAll('buy-two-offer').forEach((offer) => offer.updateState?.());
        }, 30);
      });
    }).catch((error) => console.debug('All 3 Colors size controls unavailable', error));
  }

  function init() {
    refresh();
    patchAllThreeSizes();
    observe(document.querySelector('#CartDrawer'));
    observe(document.querySelector('cart-items'));
    observe(document.querySelector('#main-cart-footer'));
    document.addEventListener('cart:refresh', schedule);
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init, { once: true })
    : init();
})();